// Cyberhaven Internal Ad Network — Site-Wide Tracker
// Source of truth: see ../../../cyberhaven-ads-v2.1.0.js (Zone 1, lines 12-206)
// Loaded on every page. Handles conversion attribution.
// IMPORTANT: keep enabledCollections regex in sync with engine.js and the
// Webflow footer snippet (webflow-footer-snippet-new.html).

(function() {
    'use strict';

    // Double-load guard. During cutover the inline v2.1.0 blob and this
    // bundle could briefly co-exist; without this, both register listeners
    // and double-fire conversion events.
    if (window.__cyberhavenTrackerLoaded) return;
    window.__cyberhavenTrackerLoaded = true;

    var ATTRIBUTION_WINDOW_DAYS = 7;
    var CONVERSION_DEDUPE_WINDOW = 30000;
    var sessionConversions = new Set();
    var recentConversions = new Map();

    function getLastAdClick() {
        var stored = localStorage.getItem('cyberhaven_last_ad_click');
        if (!stored) return null;
        try {
            var data = JSON.parse(stored);
            if (data.expires && Date.now() > data.expires) {
                localStorage.removeItem('cyberhaven_last_ad_click');
                return null;
            }
            return data;
        } catch (e) {
            localStorage.removeItem('cyberhaven_last_ad_click');
            return null;
        }
    }

    function isWithinAttributionWindow(clickTimestamp) {
        var windowMs = ATTRIBUTION_WINDOW_DAYS * 24 * 60 * 60 * 1000;
        return (Date.now() - clickTimestamp) < windowMs;
    }

    function trackConversion(conversionType, adClick, additionalData) {
        additionalData = additionalData || {};
        var timeSinceClick = Date.now() - adClick.timestamp;
        var dedupeKey = conversionType + '_' + adClick.trackingId + '_' + adClick.timestamp;

        var lastConversion = recentConversions.get(dedupeKey);
        if (lastConversion && (Date.now() - lastConversion) < CONVERSION_DEDUPE_WINDOW) return;

        recentConversions.set(dedupeKey, Date.now());

        recentConversions.forEach(function(ts, key) {
            if (Date.now() - ts > CONVERSION_DEDUPE_WINDOW) recentConversions.delete(key);
        });

        var conversionData = {
            event: 'internal_ad_conversion_' + conversionType,
            conversionType: conversionType,
            attributedTo: adClick.trackingId,
            attributedCampaign: adClick.campaign,
            attributedAdType: adClick.adType,
            timeSinceClick: timeSinceClick,
            timeSinceClickMinutes: Math.round(timeSinceClick / 60000),
            sessionId: 'sitewide_' + Date.now(),
            originalSessionId: adClick.sessionId,
            conversionUrl: window.location.href,
            referrer: document.referrer,
            dedupeKey: dedupeKey
        };

        for (var k in additionalData) {
            if (additionalData.hasOwnProperty(k)) conversionData[k] = additionalData[k];
        }

        if (window.posthog && window.posthog.capture) {
            window.posthog.capture('internal_ad_conversion', conversionData);
        }
    }

    function setupSitewideConversionTracking() {
        document.addEventListener('click', function(e) {
            var element = e.target.closest('a, button');
            if (!element) return;

            if (element.classList.contains('cyberhaven-ad-link')) return;

            var lastClick = getLastAdClick();
            if (!lastClick || !isWithinAttributionWindow(lastClick.timestamp)) return;

            var conversionKey = lastClick.trackingId + '_' + lastClick.timestamp;
            if (sessionConversions.has(conversionKey)) return;

            // Ungated assets: "download" is the primary conversion. Must also
            // catch href-less <button> CTAs and the HTML download attribute.
            var href = element.href || '';
            var text = (element.textContent || '').toLowerCase();
            var isDownload = element.hasAttribute('download') ||
                             text.indexOf('download') !== -1 ||
                             (href && (href.indexOf('.pdf') !== -1 ||
                                       href.indexOf('/download') !== -1 ||
                                       href.indexOf('download=') !== -1));
            if (isDownload) {
                trackConversion('download_action', lastClick, {
                    downloadUrl: href,
                    linkText: (element.textContent || '').trim()
                });
            }

            if (element.textContent && element.textContent.toLowerCase().indexOf('demo') !== -1) {
                trackConversion('demo_request', lastClick, {
                    buttonText: element.textContent,
                    buttonUrl: element.href || ''
                });
            }

            if (element.textContent && element.textContent.toLowerCase().indexOf('sign up') !== -1) {
                trackConversion('signup_start', lastClick, {
                    buttonText: element.textContent,
                    buttonUrl: element.href || ''
                });
            }
        });

        document.addEventListener('submit', function(e) {
            var form = e.target;
            var lastClick = getLastAdClick();

            var isHubSpotForm = form.querySelector('[data-hs-cf-bound="true"]') ||
                                (form.id && form.id.indexOf('hsForm') !== -1) ||
                                (form.className && form.className.indexOf('hs-form') !== -1);

            if (!isHubSpotForm && lastClick && isWithinAttributionWindow(lastClick.timestamp)) {
                var conversionKey = lastClick.trackingId + '_' + lastClick.timestamp;
                sessionConversions.add(conversionKey);
                trackConversion('form_submit', lastClick, {
                    formId: form.id || 'unknown',
                    formAction: form.action,
                    formClasses: form.className
                });
            }
        });

        var formDoneElements = document.querySelectorAll('.w-form-done');
        if (formDoneElements.length > 0) {
            var formSuccessObserver = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.type !== 'attributes' || mutation.attributeName !== 'style') return;
                    var el = mutation.target;
                    var computedDisplay = window.getComputedStyle(el).display;
                    if (computedDisplay === 'none') return;

                    var lastClick = getLastAdClick();
                    if (!lastClick || !isWithinAttributionWindow(lastClick.timestamp)) return;

                    var conversionKey = lastClick.trackingId + '_' + lastClick.timestamp;
                    if (sessionConversions.has(conversionKey + '_wf_success')) return;
                    sessionConversions.add(conversionKey + '_wf_success');

                    var parentForm = el.closest('.w-form');
                    trackConversion('webflow_form_success', lastClick, {
                        formId: parentForm ? (parentForm.querySelector('form') || {}).id || 'unknown' : 'unknown',
                        formClasses: parentForm ? parentForm.className : '',
                        conversionPage: window.location.pathname
                    });
                });
            });
            formDoneElements.forEach(function(el) {
                formSuccessObserver.observe(el, { attributes: true, attributeFilter: ['style'] });
            });
        }

        window.addEventListener('message', function(event) {
            if (event.data && event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
                var lastClick = getLastAdClick();
                if (lastClick && isWithinAttributionWindow(lastClick.timestamp)) {
                    var conversionKey = lastClick.trackingId + '_' + lastClick.timestamp;
                    sessionConversions.add(conversionKey);
                    trackConversion('hubspot_form_submit', lastClick, {
                        formId: event.data.id || 'hubspot_form',
                        hubspotData: event.data
                    });
                }
            }
        });

        var currentPath = window.location.pathname;
        var lastClick = getLastAdClick();
        if (lastClick && isWithinAttributionWindow(lastClick.timestamp)) {
            if (currentPath.indexOf('/thank-you') !== -1 || currentPath.indexOf('/success') !== -1) {
                trackConversion('page_conversion', lastClick, { conversionPage: currentPath });
            }
            if (currentPath.indexOf('/demo') !== -1 || currentPath.indexOf('/request-demo') !== -1) {
                trackConversion('demo_page_visit', lastClick, { landingPage: currentPath });
            }
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setupSitewideConversionTracking);
    } else {
        setupSitewideConversionTracking();
    }
})();
